import { render, staticRenderFns } from "./EmployeeRemunerations.vue?vue&type=template&id=f045277a&lang=pug&"
import script from "./EmployeeRemunerations.vue?vue&type=script&lang=js&"
export * from "./EmployeeRemunerations.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeRemunerations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EmployeeRemunerations.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VCardText,
  VFlex,
  VLayout,
})
